import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isForYou = ['Quieres un cambio real y sostenible de adentro hacia afuera', 'Estás dispuesta a comprometerte contigo misma por 90 días', 'Tienes la mente abierta para desaprender viejos hábitos', 'Buscas sanar tu relación con la comida y tu cuerpo', 'Quieres recuperar tu energía y vitalidad diaria'];
const notForYou = ['Buscas una pastilla mágica o atajos rápidos', 'Quieres perder 10 kilos en 7 días sin importar el costo', 'No estás lista para invertir tiempo y energía en ti', 'Prefieres seguir dietas restrictivas y contar calorías', 'No estás dispuesta a trabajar tu mentalidad y emociones'];
export function ForWhom() {
  return <section className="py-24 bg-white relative" data-id="element-123">
      <div className="max-w-6xl mx-auto px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="font-serif text-3xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-126">
            Seamos honestas...
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-127">
            Este programa requiere compromiso. Queremos asegurarnos de que
            estamos en la misma sintonía antes de comenzar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-128">
          {/* ES PARA TI */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-cream/50 p-8 md:p-10 rounded-3xl border-t-4 border-gold shadow-sm" data-id="element-129">
            <h3 className="font-serif text-2xl mb-8 flex items-center gap-3 text-[#0D1B3E]" data-id="element-130">
              <span className="bg-gold/20 p-2 rounded-full" data-id="element-131">
                <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-132" />
              </span>
              ES PARA TI SI...
            </h3>
            <ul className="space-y-5" data-id="element-133">
              {isForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-134">
                  <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0 mt-1" data-id="element-135" />
                  <span className="text-navy/80 font-medium" data-id="element-136">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO ES PARA TI */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="p-8 md:p-10 rounded-3xl border-t-4 border-navy/20 shadow-sm bg-[#FAF8F5]" data-id="element-137">
            <h3 className="font-serif text-2xl mb-8 flex items-center gap-3 text-[#0D1B3E]" data-id="element-138">
              <span className="bg-red-500/10 p-2 rounded-full" data-id="element-139">
                <XCircle className="w-6 h-6 text-red-500/70" data-id="element-140" />
              </span>
              NO ES PARA TI SI...
            </h3>
            <ul className="space-y-5" data-id="element-141">
              {notForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-142">
                  <XCircle className="w-5 h-5 text-red-500/50 flex-shrink-0 mt-1" data-id="element-143" />
                  <span className="text-navy/60" data-id="element-144">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}